











import { Vue, Component, Prop } from 'vue-property-decorator'
import BaseModal from '@/popupcomponents/BaseModal.vue'

@Component({
  components: {
    BaseModal
  }
})
export default class IconModal extends Vue {
  @Prop({ type: String, default: 'neutral' }) readonly alertClass!: string
  @Prop({ type: String, required: true }) readonly iconClass!: string
}
